import React from "react";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/Logo.png";
import WarehouseBg from "../assets/warehouse-bg.jpg";

export default function StartPage() {
  const navigate = useNavigate();

  return (
    <div
      className="start-page"
      style={{
        backgroundImage: `linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.9)), url(${WarehouseBg})`,
      }}
    >
      {/* CONTENT CARD */}
      <div className="content-card">
        <img src={Logo} alt="CSC Logo" className="logo" />

        <h1 className="page-header">Warehouse Management System</h1>
        <p className="page-subtitle">
        
     
          Precision in Every Move
        </p>

        <button className="page-button" onClick={() => navigate("/login")}>
          Get Started
        </button>
      </div>

      <style>{`
        .start-page {
          min-height: 100vh;
          background-size: cover;
          background-position: center;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: "Inter", Arial, sans-serif;
        }

        .content-card {
          background: rgba(255, 255, 255, 0.97);
          padding: 3.5rem 4rem;
          border-radius: 18px;
          box-shadow: 0 25px 50px rgba(0,0,0,0.2);
          text-align: center;
        }

        /*  BIGGER LOGO */
        .logo {
          width: 300px;
          margin-bottom: 1.8rem;
        }

        .page-header {
          font-size: 1.6rem;
          font-weight: 600;
          color: #e30016;
          margin-bottom: 1rem;
        }

        .page-subtitle {
          font-size: 1.2rem;
          color: #333;
          margin-bottom: 2.4rem;
          line-height: 1.6;
        }

        .page-button {
          background-color: #e30016;
          color: #fff;
          font-weight: 600;
          padding: 14px 48px;
          border: none;
          border-radius: 32px;
          cursor: pointer;
          box-shadow: 0 12px 28px rgba(239, 234, 234, 0.45);
          transition: all 0.3s ease;
          font-size: 1.2rem;
        }

        .page-button:hover {
          background-color: #c70012;
          transform: translateY(-2px) scale(1.06);
        }

        @media (max-width: 640px) {
          .content-card {
            padding: 2.2rem;
            margin: 1rem;
          }

          .logo {
            width: 120px;
          }

          .page-header {
            font-size: 2.4rem;
          }
        }
      `}</style>
    </div>
  );
}
